jQuery(document).ready(() => {
  
  $(".js-banner").each(function () {
    let id = $(this).data('id');  

    $(this).slick({
      dots: false,
      adaptiveHeight: true,
      fade: true,
      arrows: true,
      nextArrow: jQuery('.js-next[data-id="' + id + '"]'),
      prevArrow: jQuery('.js-prev[data-id="' + id + '"]')
    });
  });

  
});